import { useQuery } from 'react-query';

// configs
import { API } from 'configs/api';
//types
import { AnnotationItem } from './types';
// keys
import { detailsQueryKeys } from './detailsQueryKeys';
// utils
import { toMMSS } from 'utils/date';
import {
  getMergeCodeFromUrl,
  getSampleFromUrl,
  getShortUrlFromUrl,
} from 'utils/url';

enum LINK_TYPE {
  WEB = 'Web',
  EMAIL = 'Email',
  PHONE = 'Phone',
}

enum ANNOTATION_TYPE {
  IMAGE = 'image',
}

export const wrapAnnotationWithProps = (
  annotation: AnnotationItem,
  options?: {
    isCompanyAnnotation: boolean;
  }
): AnnotationItem => {
  const isWeb = annotation.linkType === LINK_TYPE.WEB && annotation.url;
  const isEmail = annotation.linkType === LINK_TYPE.EMAIL && annotation.email;
  const isPhone = annotation.linkType === LINK_TYPE.PHONE && annotation.phone;

  const newAnnotation: AnnotationItem = {
    ...annotation,
    startTimeText: toMMSS(annotation.startTime, 0),
    endTimeText: toMMSS(annotation.endTime, 0),
    isLinkEnabled: !!(isWeb || isEmail || isPhone),
    url: annotation.url || '',
    email: annotation.email || '',
    phone: annotation.phone || '',
  };

  if (options && options.isCompanyAnnotation) {
    newAnnotation.type = ANNOTATION_TYPE.IMAGE;
  }

  return newAnnotation;
};

export const fetchPlaybackDetails = async () => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    throw new Error('Invalid url');
  }

  const sample = getSampleFromUrl();

  const response = await API.get(`/playback/${shortUrl}/details`, {
    params: { sample, email: getMergeCodeFromUrl() },
  });

  // redirect to new shorturl if needed
  if (response.data.redirectShortUrl) {
    window.location.href = response.data.redirectShortUrl;
    return null;
  }

  return response.data;
};

export const usePlaybackDetailsQuery = () => {
  return useQuery(detailsQueryKeys.all(), fetchPlaybackDetails, {
    select: response => {
      const { annotations, companyAnnotations } = response;

      const formattedVideoAnnotations = annotations.map(
        (annotation: AnnotationItem) => wrapAnnotationWithProps(annotation)
      );
      const formattedCompanyAnnotations = companyAnnotations.map(
        (annotation: AnnotationItem) =>
          wrapAnnotationWithProps(annotation, { isCompanyAnnotation: true })
      );

      return {
        ...response,
        annotations: formattedVideoAnnotations,
        companyAnnotations: formattedCompanyAnnotations,
      };
    },
  });
};
